"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoarAbilityHandler = exports.RoarActorAbilityFactory = exports.RoarAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
class RoarAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Roar;
        this.__typeName = "Roar";
    }
}
exports.RoarAbilityArgs = RoarAbilityArgs;
let RoarActorAbilityFactory = class RoarActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Roar", "AllAllies", 3);
    }
};
RoarActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Roar")
], RoarActorAbilityFactory);
exports.RoarActorAbilityFactory = RoarActorAbilityFactory;
let RoarAbilityHandler = class RoarAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        for (const allyId of container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)) {
            container.applyBuff({
                sequence,
                creatorId: ability.invokerId,
                targetId: allyId,
                effect: new __1.LinkedEffectsEffectArgs(Array.from(__1.PRIMARY_ATTRIBUTES).map(attr => new __1.MaxAttributeIncreaseEffectArgs(attr, container.getPercentOfBaseAttributeScore(allyId, 10, attr))), false),
                duration: Duration_1.Duration.Turns(2),
            });
        }
    }
};
RoarAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Roar)
], RoarAbilityHandler);
exports.RoarAbilityHandler = RoarAbilityHandler;
